import React, { Fragment, useState } from "react";
import { Link } from "react-router";
import {
  OneWayLinkIcon,
  TwoWayLinkIcon,
  UnlinkIcon,
} from "../../../assets/icons/index";
import Constant from "../../../utils/constant";
import ConfirmationPopup from "../../shared/common/confirmationPopup";
import { deleteLinking } from "../../../api/standardLinking.service";
import { toast } from "react-toastify";

interface LinkedStandardDetailPros {
  linkingType: string;
  subject: string;
  subjectId: number;
  domain: string;
  domainId: number;
  destinationStandardId: number;
  code: string;
  name: string;
  totalQuestions: number;
  percentage: number;
  sourceStandardId?: number;
  bindStandards: () => void;
}

function LinkedStandardDetail(props: LinkedStandardDetailPros) {
  const {
    linkingType,
    subject,
    subjectId,
    domain,
    domainId,
    destinationStandardId,
    name,
    code,
    totalQuestions,
    sourceStandardId,
  } = props;

  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  function handleDeleteConfimation(confirmAction: boolean) {
    setShowConfirmation(false);
    if (confirmAction) {
      if (sourceStandardId) {
        deleteLinking(0, sourceStandardId, destinationStandardId.toString())
          .then(() => {
            toast.success("Standard unlinked successfully");
            props.bindStandards();
          })
          .catch(() => {
            toast.error("Something went wrong");
          });
      }
    }
  }

  function handleUnlinkStandard() {
    setShowConfirmation(true);
  }

  return (
    <Fragment>
      {showConfirmation && (
        <ConfirmationPopup
          title={"Unlink Standard"}
          confirmAction={handleDeleteConfimation}
          message={"Are you sure you want to unlink?"}
          buttonText={"Yes"}
        />
      )}
      <div
        className={`${
          linkingType === Constant.StandardLinkingType.TWOWAY
            ? "bg-gray-100"
            : ""
        }  sm:pr-6 lg:pr-8 lg:flex-shrink-0 lg:border-l lg:border-gray-200 xl:pr-0  shadow overflow-hidden border border-gray-200 sm:rounded-lg`}
      >
        <div className="p-4 relative">
          <span className="absolute right-4 top-4 text-primary-color font-medium">
            {linkingType.trim() ===
            Constant.StandardLinkingType.ONEWAY.trim() ? (
              <OneWayLinkIcon />
            ) : (
              <TwoWayLinkIcon />
            )}
          </span>
          <div>
            <Link
              to={Constant.SUBJECTDETAIL.replace(":id", subjectId.toString())}
              className="block"
            >
              <h3>
                <span> {subject}</span>
              </h3>
            </Link>

            <Link
              to={Constant.EDITDOMAIN.replace(":id", domainId.toString())}
              className="block"
            >
              <p className="text-xs mt-2 text-gray-600">
                <span>{domain}</span>
              </p>
            </Link>

            <div className="flex items-center mt-2">
              <dt className="flex items-center">
                <p className="mb-0 text-xs leading-6 font-medium text-gray-900">
                  <a
                    href={Constant.EDITSTANDARD.replace(
                      ":id",
                      destinationStandardId.toString()
                    )}
                    className="block"
                  >
                    <span>{`[${destinationStandardId}] ${code} ${name}`}</span>
                  </a>
                </p>
              </dt>
              <dd className="flex items-center ml-14 mb-0 text-xs text-gray-500">
                (Questions Count: {totalQuestions})
              </dd>
              <a
                title="Unlink"
                onClick={() => handleUnlinkStandard()}
                className=" py-1 px-2 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
              >
                <UnlinkIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default LinkedStandardDetail;
